import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, CheckCircle2 } from 'lucide-react';
const PURCHASE_DATA = [{
  name: 'Carlos M.',
  city: 'Córdoba',
  province: 'Córdoba',
  time: 2
}, {
  name: 'Lucía F.',
  city: 'Rosario',
  province: 'Santa Fe',
  time: 5
}, {
  name: 'Martín G.',
  city: 'La Plata',
  province: 'Buenos Aires',
  time: 8
}, {
  name: 'Sofía R.',
  city: 'Mendoza',
  province: 'Mendoza',
  time: 12
}, {
  name: 'Juan P.',
  city: 'Salta',
  province: 'Salta',
  time: 15
}, {
  name: 'Elena S.',
  city: 'San Miguel de Tucumán',
  province: 'Tucumán',
  time: 18
}, {
  name: 'Ricardo B.',
  city: 'Mar del Plata',
  province: 'Buenos Aires',
  time: 22
}, {
  name: 'Valentina D.',
  city: 'Neuquén',
  province: 'Neuquén',
  time: 25
}, {
  name: 'Facundo L.',
  city: 'Posadas',
  province: 'Misiones',
  time: 30
}, {
  name: 'Camila V.',
  city: 'San Juan',
  province: 'San Juan',
  time: 35
}, {
  name: 'Mateo N.',
  city: 'Resistencia',
  province: 'Chaco',
  time: 40
}, {
  name: 'Julieta T.',
  city: 'Corrientes',
  province: 'Corrientes',
  time: 45
}, {
  name: 'Santiago H.',
  city: 'Bahía Blanca',
  province: 'Buenos Aires',
  time: 50
}, {
  name: 'Agustina P.',
  city: 'San Salvador de Jujuy',
  province: 'Jujuy',
  time: 55
}, {
  name: 'Nicolás A.',
  city: 'Santa Rosa',
  province: 'La Pampa',
  time: 60
}, {
  name: 'Pablo S.',
  city: 'San Luis',
  province: 'San Luis',
  time: 4
}, {
  name: 'Maria J.',
  city: 'Formosa',
  province: 'Formosa',
  time: 7
}, {
  name: 'Diego R.',
  city: 'Rawson',
  province: 'Chubut',
  time: 10
}, {
  name: 'Ana B.',
  city: 'Viedma',
  province: 'Río Negro',
  time: 14
}, {
  name: 'Gabriel C.',
  city: 'Ushuaia',
  province: 'Tierra del Fuego',
  time: 17
}, {
  name: 'Florencia M.',
  city: 'San F. del Valle de Catamarca',
  province: 'Catamarca',
  time: 21
}, {
  name: 'Leandro G.',
  city: 'La Rioja',
  province: 'La Rioja',
  time: 24
}, {
  name: 'Natalia K.',
  city: 'Santiago del Estero',
  province: 'S. del Estero',
  time: 28
}, {
  name: 'Sebastian F.',
  city: 'Paraná',
  province: 'Entre Ríos',
  time: 33
}, {
  name: 'Romina L.',
  city: 'Santa Fe',
  province: 'Santa Fe',
  time: 38
}, {
  name: 'Joaquin P.',
  city: 'Quilmes',
  province: 'Buenos Aires',
  time: 42
}, {
  name: 'Belen S.',
  city: 'Lanús',
  province: 'Buenos Aires',
  time: 48
}, {
  name: 'Tomas D.',
  city: 'San Isidro',
  province: 'Buenos Aires',
  time: 52
}, {
  name: 'Victoria G.',
  city: 'Luján de Cuyo',
  province: 'Mendoza',
  time: 57
}, {
  name: 'Ezequiel M.',
  city: 'Villa Carlos Paz',
  province: 'Córdoba',
  time: 63
}];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hasScrolled, setHasScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200 && !hasScrolled) {
        setHasScrolled(true);
        setTimeout(() => setIsVisible(true), 1000);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasScrolled]);
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => {
          setCurrentIndex(prev => (prev + 1) % PURCHASE_DATA.length);
          setIsVisible(true);
        }, 8000);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, currentIndex]);
  const current = PURCHASE_DATA[currentIndex];
  return <AnimatePresence data-id="element-154">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 50
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      scale: 0.95
    }} className="fixed bottom-6 left-6 z-[100] flex items-center gap-4 bg-primary-card/95 backdrop-blur-md border border-accent-cyan/20 p-4 rounded-2xl shadow-2xl max-w-[320px]" data-id="element-155">
          <div className="relative flex-shrink-0" data-id="element-156">
            <div className="w-12 h-12 bg-accent-cyan/10 rounded-full flex items-center justify-center text-accent-cyan font-bold text-lg" data-id="element-157">
              {current.name[0]}
            </div>
            <div className="absolute -bottom-1 -right-1 bg-accent-green rounded-full p-0.5 border-2 border-primary-card" data-id="element-158">
              <CheckCircle2 className="w-3 h-3 text-primary" data-id="element-159" />
            </div>
          </div>

          <div className="flex flex-col gap-0.5" data-id="element-160">
            <p className="text-sm font-semibold text-text-main" data-id="element-161">
              {current.name} de {current.city}, {current.province}
            </p>
            <p className="text-[12px] text-text-muted" data-id="element-162">
              Compró hace {current.time} minutos
            </p>
            <div className="flex items-center gap-1.5 mt-1" data-id="element-163">
              <span className="text-[10px] font-bold text-accent-green uppercase tracking-wider flex items-center gap-1" data-id="element-164">
                Compra Verificada
                <Star className="w-3 h-3 fill-[#FFD700] text-[#FFD700]" data-id="element-165" />
              </span>
            </div>
          </div>

          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-text-muted hover:text-text-main transition-colors" data-id="element-166">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-167">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="6 18L18 6M6 6l12 12" data-id="element-168" />
            </svg>
          </button>
        </motion.div>}
    </AnimatePresence>;
}